import { Component, OnInit } from '@angular/core';
import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { QuotesService } from "../../_services/quotes.service";

import {first} from 'rxjs/operators';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-add-quote',
  templateUrl: './add-quote.component.html',
  styleUrls: ['./add-quote.component.css']
})
export class AddQuoteComponent implements OnInit {
  addQouteForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private quotesservice: QuotesService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.addQouteForm = this.formBuilder.group({
      today_quote: ['', [Validators.required, Validators.minLength(3)]],
      today_quote_status: ['true', [Validators.required]],
    });

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  get f() { return this.addQouteForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    // stop here if form is invalid
    if (this.addQouteForm.invalid) {
      this.spinnerService.hide();
      return;
    }

    const addPayload = {
      today_quote: this.addQouteForm.controls.today_quote.value,
      today_quote_status: this.addQouteForm.controls.today_quote_status.value
    };

    this.addQuote(addPayload);

  }

  addQuote(payload) {
    this.quotesservice.addQuote(payload)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Add Quote', data.ResponseMessage);
            this.router.navigate(['/get-quotes']);
          } else {
            this.toaster.showError('Add Quote', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Quote', error.error.ResponseMessage);
        });
  }


}
